"use strict";

var home = function home() {
  var mainSlider = function mainSlider() {
    var bullets = document.querySelectorAll("[data-swipe-to]");
    var items = document.querySelectorAll("[data-slide-item]");
    var slider = new Swiper('[data-main-slider]', {
      slidesPerView: 1,
      speed: 1000,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'progressbar',
        progressbarOpposite: true
      },
      on: {
        init: function init() {
          setTimeout(function () {
            items[0].classList.add("-zoom-in");
          }, 700);
        }
      }
    });
    bullets.forEach(function (item) {
      var index = item.getAttribute("data-swipe-to");
      item.addEventListener('click', function (e) {
        slider.slideTo(index);
      });
    });
    slider.on('activeIndexChange', function (swiper) {
      bullets.forEach(function (item) {
        var index = item.getAttribute("data-swipe-to");

        if (swiper.activeIndex == index) {
          item.classList.add("-active");
        } else {
          item.classList.remove("-active");
        }
      });
    });
    slider.on('slideChangeTransitionEnd', function (swiper) {
      items.forEach(function (slide, index) {
        if (swiper.activeIndex == index) {
          slide.classList.add("-zoom-in");
        } else {
          slide.classList.remove("-zoom-in");
        }
      });
    });
  };

  var sliderScrollTo = function sliderScrollTo() {
    var button = document.querySelector("[data-scroll-to]");
    button.addEventListener('click', function () {
      window.scrollTo({
        top: window.innerHeight - 80,
        behavior: 'smooth'
      });
    });
  };

  var counter = function counter() {
    $('[data-number]').counterUp({
      delay: 10,
      time: 1000
    });
  };

  var init = function init() {
    mainSlider();
    sliderScrollTo();
    counter();
  };

  init();
};

document.addEventListener('DOMContentLoaded', home);